module.exports = __webpack_public_path__ + "static/media/mongodb.ac38b307.svg";